/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';
import Box from '@material-ui/core/Box';

interface TabPanelProps {
  children: React.ReactNode;
  index: any;
  value: any;
  // eslint-disable-next-line
  boxStyles?: React.CSSProperties;
}

function TabPanel(props: TabPanelProps) {
  const { children, index, value, boxStyles, ...other } = props;
  return (
    <div
      aria-labelledby={`tab-${index}`}
      hidden={value !== index}
      id={`tabpanel-${index}`}
      role='tabpanel'
      {...other}
      style={{ height: '100%' }}>
      {value === index && (
        <Box style={boxStyles} height='100%' p={0}>
          {children}
        </Box>
      )}
    </div>
  );
}

export { TabPanel };
export default TabPanel;
